interface DemoAccountCredentials {
  email: string;
  password: string;
}

export const getDemoAccountCredentials = (): DemoAccountCredentials => ({
  email: process.env.DEMO_USER_EMAIL || '',
  password: global.getBasedOnEnvironment<string>({
    prod: process.env.DEMO_USER_PASSWORD_PROD,
    default: process.env.DEMO_USER_PASSWORD_DEFAULT,
  }),
});
